// Tiny presentational helpers shared across Assignment / Classroom detail views.
export const StatusBadge = ({ status }) => {
  const cfg = {
    completed: { label: "Completed", cls: "bg-emerald-500/15 text-emerald-600" },
    failed: { label: "Didn't pass", cls: "bg-red-500/15 text-red-600" },
    in_progress: { label: "In progress", cls: "bg-amber-500/15 text-amber-600" },
    not_started: { label: "Not started", cls: "bg-muted/40 text-muted-foreground" },
  }[status] || { label: status, cls: "bg-muted/40 text-muted-foreground" };
  return <span className={`inline-block rounded-full px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider ${cfg.cls}`}>{cfg.label}</span>;
};

export const Stat = ({ label, value, tone }) => (
  <div className={`rounded-xl border p-4 ${tone === "accent" ? "border-accent/40 bg-accent/10" : "border-border bg-secondary/40"}`}>
    <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-semibold">{label}</div>
    <div className="mt-1 font-serif text-2xl font-bold">{value}</div>
  </div>
);
